"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.watchEvent = watchEvent, exports.unWatchEvent = unWatchEvent, exports.watchEvents = watchEvents, exports.unWatchEvents = unWatchEvents, exports.remove = remove;

var _constants = require("../constants"),
    _query = require("../utils/query");

function watchEvent(firebase, dispatch, options) {
  if (!firebase.database || "function" != typeof firebase.database) throw new Error("Firebase database is required to create watchers");
  var type = options.type,
      path = options.path,
      populates = options.populates,
      queryParams = options.queryParams,
      queryId = options.queryId,
      isQuery = options.isQuery,
      storeAs = options.storeAs,
      logErrors = firebase._.config.logErrors,
      watchPath = storeAs ? "".concat(path, "@").concat(storeAs) : path,
      id = queryId || (0, _query.getQueryIdFromPath)(path),
      counter = (0, _query.getWatcherCount)(firebase, type, watchPath, id);
  if (0 < counter && id && (0, _query.unsetWatcher)(firebase, dispatch, type, path, id), (0, _query.setWatcher)(firebase, dispatch, type, watchPath, id), "first_child" === type) return firebase.database().ref().child(path).orderByKey().limitToFirst(1).once("value").then(function (snapshot) {
    return null === snapshot.val() && dispatch({
      type: _constants.actionTypes.NO_VALUE,
      path: storeAs || path
    }), snapshot;
  })["catch"](function (err) {
    return dispatch({
      type: _constants.actionTypes.ERROR,
      path: storeAs || path,
      payload: err
    }), Promise.reject(err);
  });
  var query = firebase.database().ref().child(path);
  return isQuery && (query = (0, _query.applyParamsToQuery)(queryParams, query)), dispatch({
    type: _constants.actionTypes.START,
    path: storeAs || path
  }), "once" === type ? query.once("value").then(function (snapshot) {
    return null === snapshot.val() ? dispatch({
      type: _constants.actionTypes.NO_VALUE,
      path: storeAs || path
    }) : populates ? (0, _query.populateAndDispatch)(firebase, dispatch, {
      path: path,
      storeAs: storeAs,
      snapshot: snapshot,
      data: snapshot.val(),
      populates: populates
    }) : dispatch({
      type: _constants.actionTypes.SET,
      path: storeAs || path,
      data: snapshot.val(),
      ordered: (0, _query.orderedFromSnapshot)(snapshot)
    });
  })["catch"](function (err) {
    return dispatch({
      type: _constants.actionTypes.UNAUTHORIZED_ERROR,
      payload: err
    }), Promise.reject(err);
  }) : void query.on(type, function (snapshot) {
    var data = "child_removed" === type ? void 0 : snapshot.val(),
        resultPath = storeAs || "value" === type ? path : "".concat(path, "/").concat(snapshot.key);

    if (!populates) {
      var ordered = "child_added" === type ? [{
        key: snapshot.key,
        value: snapshot.val()
      }] : (0, _query.orderedFromSnapshot)(snapshot);
      return dispatch({
        type: _constants.actionTypes.SET,
        path: storeAs || resultPath,
        data: data,
        ordered: ordered
      });
    }

    return (0, _query.populateAndDispatch)(firebase, dispatch, {
      path: path,
      storeAs: storeAs,
      snapshot: snapshot,
      data: snapshot.val(),
      populates: populates
    });
  }, function (err) {
    logErrors && console.log("Error retrieving data for path: ".concat(path, ", storeAs: ").concat(storeAs, ". Firebase:"), err), dispatch({
      type: _constants.actionTypes.ERROR,
      storeAs: storeAs,
      path: path,
      payload: err
    });
  });
}

function unWatchEvent(firebase, dispatch, _ref) {
  var type = _ref.type,
      path = _ref.path,
      storeAs = _ref.storeAs,
      queryId = _ref.queryId,
      watchPath = storeAs ? "".concat(path, "@").concat(storeAs) : path;
  (0, _query.unsetWatcher)(firebase, dispatch, type, watchPath, queryId);
}

function watchEvents(firebase, dispatch, events) {
  if (!Array.isArray(events)) throw new Error("Events config must be an Array");
  return events.map(function (event) {
    return watchEvent(firebase, dispatch, event);
  });
}

function unWatchEvents(firebase, dispatch, events) {
  events.forEach(function (event) {
    return unWatchEvent(firebase, dispatch, event);
  });
}

function remove(firebase, dispatch, path) {
  var options = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : {},
      _options$dispatchActi = options.dispatchAction,
      dispatchRemoveAction = firebase._.config.dispatchRemoveAction;
  return firebase.database().ref(path).remove().then(function () {
    return dispatchRemoveAction && (!(void 0 !== _options$dispatchActi) || _options$dispatchActi) && dispatch({
      type: _constants.actionTypes.REMOVE,
      path: path
    }), path;
  })["catch"](function (err) {
    return dispatch({
      type: _constants.actionTypes.ERROR,
      payload: err
    }), Promise.reject(err);
  });
}